import type { IconData } from '@stacksjs/iconify-core'

export const wrenchCircleFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5\"/><path fill=\"#2859c5\" d=\"M29.601 45.797V39.69c0-1.59.974-2.987 2.287-3.884A13.98 13.98 0 0 0 38 24.24c0-5.09-2.717-9.547-6.78-11.997c-1.182-.712-2.553.242-2.553 1.622v8.223c0 .445-.147.878-.452 1.202c-.638.676-1.914 1.861-3.591 2.578c-.398.17-.849.17-1.246 0c-1.724-.736-3.023-1.967-3.642-2.632a1.7 1.7 0 0 1-.44-1.072c-.13-2.299-.171-5.234-.169-8.154c.002-1.401-1.397-2.367-2.582-1.62c-3.93 2.479-6.542 6.86-6.542 11.85c0 4.806 2.422 9.047 6.113 11.567c1.312.897 2.286 2.294 2.286 3.884v6.108A22.5 22.5 0 0 0 24 46.5c1.934 0 3.81-.244 5.601-.703\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default wrenchCircleFlat
